import SalesPage from './SalesPage';
import salesPageReducer from './reducer';

export { salesPageReducer };
export default SalesPage;
